import React, { useEffect, useState } from "react";
// import cityAutoComplete from "../helpers/cityAutoComplete";
import { AddressAutofill, Geocoder } from "@mapbox/search-js-react";
import { IoSearch } from "react-icons/io5";
// import { FaChevronDown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
// import { primaryCities } from "../data/citiesData";
import { useStateContext } from "../contexts/ContextProvider";

const SearchBox = (props) => {
  const { handleSearchDropdown, showDropdown } = props;
  const { setPublishedRooms } = useStateContext();
  const [isVisible, setIsVisible] = useState(false);
  const [citiesArray, setCitiesArray] = useState(null);
  const [hasSelectedCity, setHasSelectedCity] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState({});
  const [searchText, setSearchText] = useState("");
  const token = process.env.REACT_APP_MAPBOX_TOKEN;

  const navigate = useNavigate();

  useEffect(() => {
    // TODO: prevent from running on first render
    handleSearch();
  }, [selectedLocation]);

  const handleChange = (event) => {
    setSearchText(event);
    // const { value } = event.target;
    // setSearchText(value);
    // if (citiesArray && hasSelectedCity) {
    //   setHasSelectedCity(false);
    // }
  };

  const handleLocationDropdown = () => {
    setIsVisible(!isVisible);
  };

  const handleSelect = (location) => {
    setSearchText(location.city + ", " + location.state);
    setSelectedLocation(location);
    setHasSelectedCity(true);
  };

  const handleSearch = async () => {
    if (searchText !== "") {
      handleSearchDropdown();
      navigate(
        `/rooms?neighborhood=${selectedLocation.neighborhood || ""}&city=${
          selectedLocation.city || ""
        }&state=${selectedLocation.state || ""}&lat=${
          selectedLocation.latitude || ""
        }&long=${selectedLocation.longitude || ""}&search=${
          selectedLocation.city || selectedLocation.state ? "" : searchText
        }`
      );
    }
  };

  const getCoordinates = async (event) => {
    const { context, coordinates } = event.properties;
    console.log(context);
    setSelectedLocation({
      neighborhood: context.neighborhood ? context.neighborhood.name : "",
      city: context.locality ? context.locality.name : context.place.name,
      state: context.region.region_code,
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
    });
  };

  const theme = {
    variables: {
      fontFamily: "Open Sans, sans-serif",
      fontWeight: "bold",
      unit: "0.875rem",
      padding: "0.25rem",
      borderRadius: "0.5rem 0 0 0.5rem",
      boxShadow: "0 0 0 3px rgb(209 213 219)",
      height: "0.5rem",
    },
  };

  return (
    <div className="px-5">
      <form
        className="max-w-lg mx-auto"
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <div className="flex flex-col">
          <div className="relative w-full">
            <div
              className="py-1 pl-1 pr-12 z-20"
              onClick={() => setIsVisible(false)}
            >
              <Geocoder
                accessToken={token}
                options={{
                  streets: false,
                  country: "US", // multiple countries are possible
                  proximity: "ip",
                }}
                onRetrieve={getCoordinates}
                theme={theme}
                value={searchText}
                placeholder="Search by City, or Zip Code..."
                onChange={handleChange}
                tabIndex={-1}
              />
            </div>

            {/* <AddressAutofill accessToken={token} types="place, region, country"> */}
            {/* <input
              id="search-text"
              name="searchText"
              type="search"
              required
              maxLength={60}
              placeholder="Search by City, State, or Zip Code..."
              value={searchText}
              onChange={handleChange}
              className="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg
                border-2 border-gray-300 focus:ring-snappily-orange focus:outline-none
                focus:border-snappily-orange capitalize"
            /> */}

            {/* </AddressAutofill> */}
            <button
              type="button"
              className="absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-snappily-orange 
                border-snappily-orange border-2 rounded-e-lg focus:outline-none"
              onClick={handleSearch}
            >
              <IoSearch className="text-xl" />
              <span className="sr-only">Search</span>
            </button>
          </div>
          <div className="relative">
            {citiesArray && !hasSelectedCity && (
              <ul className="absolute h-36 w-full border-2 border-snappily-orange bg-white p-2 rounded-b-2xl z-30">
                {citiesArray.map((item, index) => {
                  return (
                    <li
                      key={item.id}
                      className="hover:cursor-pointer hover:text-blue-700 capitalize"
                      onClick={() => handleSelect(item)}
                    >
                      {item.city + ", " + item.state}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
          {/* <div
            className="relative items-center py-2.5 px-4 my-1 text-sm font-medium 
          text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200
          focus:ring-4 focus:outline-none focus:ring-gray-100"
            onClick={handleLocationDropdown}
          >
            <div className="flex justify-between items-center">
              <div>Or Select Location</div>
              <FaChevronDown className="ml-2" />
            </div>
            {isVisible && (
              <div
                id="dropdown"
                className="absolute left-0 bottom- w-44 bg-white divide-y divide-gray-100 
                rounded-lg shadow z-70"
              >
                <ul
                  className="h-96 w-44 py-2 text-sm text-gray-700 overflow-y-scroll"
                  aria-labelledby="dropdown-button"
                >
                  {primaryCities.map((item, index) => {
                    return (
                      <li key={item.id} onClick={() => handleSelect(item)}>
                        <button
                          type="button"
                          className="inline-flex w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600
                     dark:hover:text-white capitalize"
                        >
                          {item.city + ", " + item.state}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div> */}
        </div>
      </form>
    </div>
  );
};

export default SearchBox;
